module.exports = __webpack_public_path__ + "static/media/instagram.272861aa.svg";